import { Baseline } from "./Baseline";
import { BuildingSubType } from "./BuildingSubType";
import { Campus } from "./Campus";
import { Customer } from "./Customer";
import { PrimaryFunction } from "./PrimaryFunction";
import { Score } from "./Score";

export type SoftwareType =
  | "campus_optimizer"
  | "sidecar"
  | "events_for_hvac"
  | "no_calendar_software";

export const SOFTWARE_TYPE_OPTIONS: { value: SoftwareType; label: string }[] = [
  { value: "campus_optimizer", label: "Campus Optimizer" },
  { value: "sidecar", label: "Sidecar" },
  { value: "events_for_hvac", label: "Events For HVAC" },
  { value: "no_calendar_software", label: "No Calendar Software" },
];

export type ServiceType = "ai_foa" | "ai_only" | "none";

export const SERVICE_TYPE_OPTIONS: { value: ServiceType; label: string }[] = [
  { value: "ai_foa", label: "AI + FOA" },
  { value: "ai_only", label: "AI Only" },
  { value: "none", label: "No Service Type" },
];

export const hasCalendarSoftware = (type?: string | null) =>
  !!type && type !== "no_calendar_software";

export const hasServiceType = (type?: string | null) =>
  !!type && type !== "none";

// YYYY-MM-DD one year after the given YYYY-MM-DD, or "" (clamps Feb 29 to Feb 28)
export const defaultProjectEndDate = (start?: string | Date | null) => {
  if (!start) return "";
  const [y, m, d] = String(start).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return "";
  const end = new Date(Date.UTC(y + 1, m - 1, d));
  if (end.getUTCMonth() !== m - 1) end.setUTCDate(0);
  return end.toISOString().slice(0, 10);
};

export const softwareTypeLabel = (type?: string | null) =>
  SOFTWARE_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? "";

export const serviceTypeLabel = (type?: string | null) =>
  SERVICE_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? "";

export interface Building {
  uuid: string;
  cust_uuid: Customer | string;
  campus_uuid: Campus | null;
  building_name: string;
  building_description: string | null;
  building_address: string;
  building_address_2?: string | null;
  building_city: string;
  building_state: string;
  building_county?: string | null;
  building_sq_ft: string | number | null;
  building_type: PrimaryFunction | null;
  building_sub_type?: BuildingSubType | null;
  building_incentive?: string | number | null;
  estar_id?: string | number | null;
  building_zipcode: string | number;
  building_disabled?: Boolean;
  building_fan_cycle: string | number;
  software_type: SoftwareType;
  project_start_date: Date | string | null;
  project_end_date?: Date | string | null;
  service_type: ServiceType;
  service_start_date?: Date | string | null;
  service_end_date?: Date | string | null;
  fc_start_date: Date | string | null;
  latitude: number | string | null;
  longitude: number | string | null;
  foa: Boolean;
  kpi: Boolean;
  baseline?: Baseline;
  estar_score?: Score | string | null;
  project_fee?: string | number | null;
  total_cost_avoidance?: string | number | null;
  utility_cost_percent_reduction:any;
  pp_end_date: Date | string | null;  
}
